



















import Vue from "vue";
export default Vue.extend({
	name: "YTSidebarItem",
	props: {
		type: {
			type: String,
			default: "full",
			validator(v) {
				return ["full", "mini", "fixed"].includes(v);
			},
		},
		active: {
			default: false,
			type: Boolean,
		},
		to: {
			default: "#",
			type: [String, Boolean],
		},
		text: {
			default: false,
			type: [String, Boolean],
		},
		mdIcon: {
			default: false,
			type: [String, Boolean],
		},
		src: {
			default: false,
			type: [String, Boolean],
		},
	},
	computed: {
		classes() {
			return {
				"yt-bg-secondary-2": this.active,
				"pl-5": this.type === "mini",
				"pl-6": this.type !== "mini",
			};
		},
	},
});
